import { render, staticRenderFns } from "./SuperAdminBulkCreate.vue?vue&type=template&id=e834aa34"
import script from "./SuperAdminBulkCreate.vue?vue&type=script&lang=js"
export * from "./SuperAdminBulkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports